import { NAVY, fieldStyle } from '../../styles/tokens';

export default function DateRangeFilter({ dateFrom, dateTo, onChange }) {
  const today = new Date().toISOString().split('T')[0];

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <span style={{ fontSize: 13, color: '#555', fontWeight: 600 }}>Fecha:</span>
      <input
        type="date"
        value={dateFrom || ''}
        max={today}
        onChange={(e) => onChange({ dateFrom: e.target.value || null, dateTo })}
        style={{ ...fieldStyle, width: 140 }}
        placeholder="From"
      />
      <span style={{ fontSize: 13, color: '#888' }}>→</span>
      <input
        type="date"
        value={dateTo || ''}
        max={today}
        onChange={(e) => onChange({ dateFrom, dateTo: e.target.value || null })}
        style={{ ...fieldStyle, width: 140 }}
        placeholder="To"
      />
      {(dateFrom || dateTo) && (
        <button
          onClick={() => onChange({ dateFrom: null, dateTo: null })}
          style={{
            background: 'transparent',
            border: `1px solid #ccc`,
            borderRadius: 6,
            padding: '5px 10px',
            fontSize: 12,
            cursor: 'pointer',
            color: '#666',
          }}
        >
          Limpiar
        </button>
      )}
    </div>
  );
}
